$(() => {
  if ($('.risk-assessment-share')) {
    const shareSettings = {
      allCheckboxes: [].slice.call(
        $("input[name='master_activity[trade_ids][]']"),
      ),

      setup() {
        this.checkboxEvents();
        this.disableCheckbox();
        this.formSubmitEvent();
      },

      checkboxEvents() {
        const _this = this;

        this.allCheckboxes.forEach((checkbox) => {
          $(checkbox).change((_event) => {
            _this.disableCheckbox();
            _this.updateFormAction();
          });
        });
      },

      disableCheckbox() {
        const checkedCheckboxes = $(
          "input[name='master_activity[trade_ids][]']:checked",
        );

        if (checkedCheckboxes.length === 1) {
          $(checkedCheckboxes[0]).prop('disabled', true);
        } else {
          [].slice.call(checkedCheckboxes).forEach((checkbox) => {
            $(checkbox).prop('disabled', false);
          });
        }
      },

      updateFormAction() {
        const firstCheckedCheckbox = $(
          "input[name='master_activity[trade_ids][]']:checked",
        )[0];

        $('form').attr('action', $(firstCheckedCheckbox).data('url'));
      },

      formSubmitEvent() {
        $('form').submit((_event) => {
          $('input').prop('disabled', false);
        });
      },
    };

    shareSettings.setup();
  }
});
